import { cn } from "@omni/utils/styles";

import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";

type Props = {
    className?: string;
};

export const Content = ({ className }: Props) => {
    const { hiddenText, text } = useHeaderButtonContext();

    return (
        <span
            className={cn(
                "tw:hidden tw:lg:inline",
                {
                    "tw:sr-only": hiddenText
                },
                className
            )}
        >
            {text}
        </span>
    );
};
